import api from 'api';
import { components } from 'api/types';

export type NodeDrainStatus = components['schemas']['NodeDrainStatus'];
export type NodeDrainResumeResult = components['schemas']['NodeDrainResumeResult'];

export function drainNode(nodeAgentId: string) {
  return api.post(`node-agents/${nodeAgentId}/drain`).json<NodeDrainStatus>();
}

export function resumeNode(nodeAgentId: string) {
  return api.post(`node-agents/${nodeAgentId}/resume`).json<NodeDrainResumeResult>();
}
